import { isEmpty, uniqueId } from 'lodash'

export const getImageColumn = (columns) => {
  if (isEmpty(columns)) return null

  return columns?.find((column) => {
    return column?.its_an_image === true
  })
}

export const getTextColumn = (columns) => {
  if (isEmpty(columns)) return null

  return columns?.find((column) => {
    return column?.its_an_image === false
  })
}

export const getRowData = (row) => {
  const rowKey = uniqueId()

  const column1 = row?.column1
  const column2 = row?.column2

  const columns = [column1, column2]

  const allImage = columns?.every((column) => column?.its_an_image === true)
  const allText = columns?.every((column) => column?.its_an_image === false)

  const imageColumn = getImageColumn(columns)
  const textColumn = getTextColumn(columns)

  return { allImage, allText, columns, rowKey, imageColumn, textColumn }
}
